import { GridItem } from '@bnnvara/grids';
import { formatDate } from '@bnnvara/helpers';
import BaseMetaBlock from '@bnnvara/metablocks';
import { Heading } from '@bnnvara/typography';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../helpers/resizeImageSource';

const ComposableMediaHeader = ({ title, publishDate, image }) => {
  const brandLogo = image
    ? resizeImageSource(image.url)
    : '/static/fallbackImages/videofallback.jpg';

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <Heading element="h1" variant="one">
        {title}
      </Heading>
      <BaseMetaBlock
        title={title}
        publicationDate={formatDate(new Date(publishDate), 'dd-MM-yyyy')}
        brandLogo={brandLogo}
        brandLogoAltText={get(image, 'altText', title)}
      />
    </GridItem>
  );
};

ComposableMediaHeader.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    altText: PropTypes.string,
  }).isRequired,
  publishDate: PropTypes.string.isRequired,
};

export default ComposableMediaHeader;
